import React, { useState, useEffect } from "react";
import OffCanvas from "../../OffCanvas/OffCanvas";
import SearchInput from "../../SerachInput/SearchInput";
import useCustomFecthQuery from "../../../Hooks/useCustomFecthQuery";
import useCustomMutation from "../../../Hooks/useCustomMutation";
import ModalDelete from "../../Modal/ModalDelete";
import Nothing from "../../Loader/Contacts";
import ButtonIcon from "../../Buttons/ButtonIcon";
import DataTable from "react-data-table-component";
import { FaPlus } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { AiFillEye } from "react-icons/ai";
import { CgAttachment } from "react-icons/cg";
import { BsPersonFillAdd } from "react-icons/bs";
import { AiFillDelete } from "react-icons/ai";
import Tooltip from "../../../utils/toolTip";
import AddSession from "./AddSession";
import ViewSession from "./ViewSession";
import EditSession from "./EditSession";
import AttachSessionDocument from "./AttachSessionDocument";
import AssignUser from "./AssignUser";
import DeleteForm from "./DeleteForm";

const Sessions = ({ eventDetails, token, userID }) => {
  const [isAddSession, setIsAddSession] = useState(false);
  const [isViewSession, setIsViewSession] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDocAttach, setIsDocAttach] = useState(false);
  const [isUserAssign, setUserAssign] = useState(false);
  const [isToggleDelete, setIsToggleDelete] = useState(false);
  const [search, setSearch] = useState(null);
  const [sessionID, setSessionID] = useState(null);
  const [sessionDetails, setSessionDetails] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const canvasWidth = isMobile ? "100%" : 500;

  const key = ["mySessions", eventDetails?._id];

  const {
    data: getMySessions,
    error: errorGetMySessions,
    isLoading: isLoadingGetMySessions,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}sessions/event/${eventDetails?._id}`,
    token,
    {
      enabled: !!eventDetails?._id,
    }
  );

  const tog_viewSession = (details) => {
    setIsViewSession(!isViewSession);
    setSessionDetails(details);
  };

  const tog_editSession = (details) => {
    setSessionDetails(details);
    setIsEdit(!isEdit);
  };

  const tog_attachDoc = (id) => {
    setSessionID(id);
    setIsDocAttach(!isDocAttach);
  };

  const tog_assignUser = (id) => {
    setUserAssign(!isUserAssign);
    setSessionID(id);
  };

  const tog_deleteSession = (id) => {
    setSessionID(id);
    setIsToggleDelete(!isToggleDelete);
  };

  const columns = [
    {
      name: <span>Session</span>,
      selector: (row) => row?.sessionName,
      sortable: true,
      grow: 2,
      style: {
        fontWeight: "600",
        fontSize: isMobile ? "12px" : "14px",
      },
      cell: (row) => (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            paddingRight: "8px",
          }}
          title={row?.sessionName}
        >
          {row?.sessionName || "N/A"}
        </div>
      ),
    },
    {
      name: <span>Type</span>,
      selector: (row) => row?.sessionFormat,
      sortable: true,
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => (
        <div style={{ paddingRight: "8px", whiteSpace: "nowrap" }}>
          {row?.sessionFormat || "N/A"}
        </div>
      ),
    },
    {
      name: <span>Speakers</span>,
      sortable: true,
      hide: isMobile, // Hide on mobile to save space
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {row?.speakers?.slice(0, 3)?.map((speaker, i) => {
              return (
                <div
                  key={i}
                  style={{
                    width: isMobile ? "24px" : "30px",
                    height: isMobile ? "24px" : "30px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "2px solid white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    src={speaker?.photo}
                    alt={speaker?.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.parentNode.innerHTML = `<div style="width:100%;height:100%;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-size:10px;color:#6b7280;">${(speaker?.name?.charAt(0)||'?').toUpperCase()}</div>`;
                    }}
                  />
                </div>
              );
            })}
            {row?.speakers?.length > 3 && (
              <span style={{ fontSize: "11px", color: "#6b7280" }}>
                +{row.speakers.length - 3}
              </span>
            )}
          </div>
        );
      },
    },
    {
      name: <span>Status</span>,
      sortable: true,
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => {
        const statusColors = {
          scheduled: "#3b82f6",
          ongoing: "#10b981",
          completed: "#6b7280",
          cancelled: "#ef4444",
        };
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "12px",
              fontSize: "11px",
              fontWeight: "600",
              backgroundColor: `${statusColors[row?.status?.toLowerCase()] || "#e5e7eb"}20`,
              color: statusColors[row?.status?.toLowerCase()] || "#6b7280",
              whiteSpace: "nowrap",
            }}
          >
            {row?.status || "N/A"}
          </span>
        );
      },
    },
    {
      name: <span>Date</span>,
      selector: (row) => row?.sessionDate,
      sortable: true,
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => (
        <div style={{ paddingRight: "8px", whiteSpace: "nowrap" }}>
          {row?.sessionDate ? new Date(row.sessionDate).toLocaleDateString() : "N/A"}
        </div>
      ),
    },
    {
      name: <span>Time</span>,
      selector: (row) => row?.startTime,
      sortable: true,
      hide: isMobile, // Hide on mobile
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => (
        <div style={{ paddingRight: "8px", whiteSpace: "nowrap" }}>
          {row?.startTime ? new Date(`2000-01-01T${row.startTime}`).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : "N/A"}
        </div>
      ),
    },
    {
      name: <span>Actions</span>,
      cell: (row) => {
        const buttonSize = isMobile ? 32 : 36;
        const iconSize = isMobile ? 14 : 18;
        const gapSize = isMobile ? 4 : 8;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: `${gapSize}px`,
              flexWrap: "nowrap",
            }}
          >
            <button
              onClick={() => tog_viewSession(row)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#0d6efd",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(13, 110, 253, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="View Session"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(13, 110, 253, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(13, 110, 253, 0.35)";
              }}
            >
              <AiFillEye size={iconSize} />
            </button>

            <button
              onClick={() => tog_editSession(row)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#ffc107",
                color: "#000000",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(255, 193, 7, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="Edit Session"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(255, 193, 7, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(255, 193, 7, 0.35)";
              }}
            >
              <FaEdit size={iconSize} />
            </button>

            <button
              onClick={() => tog_attachDoc(row?._id)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#6b7280",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(107, 114, 128, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="Attach Document"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(107, 114, 128, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(107, 114, 128, 0.35)";
              }}
            >
              <CgAttachment size={iconSize} />
            </button>

            <button
              onClick={() => tog_assignUser(row?._id)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#8b5cf6",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(139, 92, 246, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="Assign User"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(139, 92, 246, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(139, 92, 246, 0.35)";
              }}
            >
              <BsPersonFillAdd size={iconSize} />
            </button>

            <button
              onClick={() => tog_deleteSession(row?._id)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#dc3545",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(220, 53, 69, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="Delete Session"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(220, 53, 69, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(220, 53, 69, 0.35)";
              }}
            >
              <AiFillDelete size={iconSize} />
            </button>
          </div>
        );
      },
      center: true,
      minWidth: isMobile ? "180px" : "240px",
    },
  ];

  const customStyles = {
    tableWrapper: {
      style: {
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f8f9fa",
        borderBottomWidth: "2px",
        borderBottomColor: "#e9ecef",
        minHeight: "48px",
      },
    },
    headCells: {
      style: {
        fontSize: isMobile ? "10px" : "12px",
        fontWeight: "700",
        color: "#495057",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        paddingLeft: isMobile ? "8px" : "12px",
        paddingRight: isMobile ? "8px" : "12px",
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        fontSize: isMobile ? "11px" : "13px",
        color: "#212529",
        paddingLeft: isMobile ? "8px" : "12px",
        paddingRight: isMobile ? "8px" : "12px",
        minHeight: "60px",
      },
    },
    rows: {
      style: {
        "&:hover": {
          backgroundColor: "#f8f9fa",
        },
        borderBottomWidth: "1px",
        borderBottomColor: "#e9ecef",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#ffffff",
        borderTopWidth: "1px",
        borderTopColor: "#e9ecef",
        minHeight: "52px",
        fontSize: "13px",
      },
    },
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  if (getMySessions?.data?.length === 0 && getMySessions?.status === "ok") {
    return (
      <div style={styles.container}>
        <div style={styles.headerSection}>
          <h1 style={styles.mainTitle}>Sessions</h1>
          <p style={styles.subtitle}>
            Add and manage all sessions and invite speakers to your different
            sessions. Your invited speakers will receive session invitations via
            their email.
          </p>
        </div>

        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>🎬</div>
          <h4 style={styles.emptyTitle}>No sessions yet</h4>
          <p style={styles.emptyText}>Start by adding your first session</p>
          <button
            onClick={() => setIsAddSession(true)}
            style={styles.addButton}
            type="button"
          >
            <FaPlus size={16} />
            <span>Add Session</span>
          </button>
        </div>

        <OffCanvas
          isOffcanvasOpen={isAddSession}
          title="Add Session"
          body={
            <AddSession
              userID={userID}
              token={token}
              eventID={eventDetails?._id}
              eventFormat={eventDetails?.eventFormat}
              setIsOffcanvasOpen={setIsAddSession}
            />
          }
          toggleSaveChanges={() => setIsAddSession(false)}
          directionOffCanvas="end"
          widthOffCanvas={canvasWidth}
        />
      </div>
    );
  }

  // Sorting sessions by sessionDate
  const sortedSessions = [...(getMySessions?.data || [])].sort((a, b) =>
    a.sessionDate.localeCompare(b.sessionDate)
  );

  const filterSessions = (session, searchQuery) => {
    if (!searchQuery) return session;
    return session?.filter((item) =>
      [item?.sessionName, item?.sessionFormat].some((field) =>
        field?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  };

  const filteredSession = filterSessions(sortedSessions, search);

  return (
    <div style={styles.container}>
      {/* Header Section */}
      <div style={styles.headerSection}>
        <h1 style={styles.mainTitle}>Sessions</h1>
        <p style={styles.subtitle}>
          Add and manage all sessions and invite speakers to your different
          sessions. Your invited speakers will receive session invitations via
          their email.
        </p>
      </div>

      {/* Search and Button Section */}
      <div style={styles.controlsContainer}>
        <div style={styles.searchWrapper}>
          <input
            type="text"
            placeholder="Search sessions..."
            value={search || ""}
            onChange={handleSearch}
            style={styles.searchInput}
          />
          {search && (
            <button
              onClick={() => setSearch("")}
              style={styles.clearButton}
              type="button"
            >
              ×
            </button>
          )}
        </div>

        <button
          onClick={() => setIsAddSession(true)}
          style={styles.addButton}
          type="button"
        >
          <FaPlus size={16} />
          <span>Add Session</span>
        </button>
      </div>

      {/* Table Section */}
      <div style={styles.tableContainer}>
        <div style={styles.tableHeader}>
          <span style={styles.tableLabel}>Session List</span>
          <span style={styles.tableCount}>
            {filteredSession?.length || 0} sessions
          </span>
        </div>
        <div style={styles.tableWrapper}>
          <DataTable
            columns={columns}
            data={filteredSession || []}
            responsive
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50]}
            customStyles={customStyles}
            highlightOnHover
            noDataComponent={
              <div style={styles.noData}>No sessions match your search</div>
            }
          />
        </div>
      </div>

      {/* OffCanvas Components */}
      <OffCanvas
        isOffcanvasOpen={isUserAssign}
        title="Assign Host/Speaker"
        body={
          <AssignUser
            userID={userID}
            token={token}
            eventID={eventDetails?._id}
            eventDetails={eventDetails}
            sessionID={sessionID}
            eventFormat={eventDetails?.eventFormat}
            setIsOffcanvasOpen={setUserAssign}
          />
        }
        toggleSaveChanges={() => setUserAssign(false)}
        directionOffCanvas="end"
        widthOffCanvas={canvasWidth}
      />

      <OffCanvas
        isOffcanvasOpen={isAddSession}
        title="Add Session"
        body={
          <AddSession
            userID={userID}
            token={token}
            eventID={eventDetails?._id}
            eventFormat={eventDetails?.eventFormat}
            setIsOffcanvasOpen={setIsAddSession}
          />
        }
        toggleSaveChanges={() => setIsAddSession(false)}
        directionOffCanvas="end"
        widthOffCanvas={canvasWidth}
      />

      <OffCanvas
        isOffcanvasOpen={isViewSession}
        title="Session Details"
        body={<ViewSession sessionDetails={sessionDetails} />}
        toggleSaveChanges={() => setIsViewSession(false)}
        directionOffCanvas="end"
        widthOffCanvas={canvasWidth}
      />

      <OffCanvas
        isOffcanvasOpen={isEdit}
        title="Edit Session"
        body={
          <EditSession
            sessionDetails={sessionDetails}
            eventID={eventDetails?._id}
            token={token}
            setIsOffcanvasOpen={setIsEdit}
          />
        }
        toggleSaveChanges={() => setIsEdit(false)}
        directionOffCanvas="end"
        widthOffCanvas={canvasWidth}
      />

      <OffCanvas
        isOffcanvasOpen={isDocAttach}
        title="Session Document"
        body={
          <AttachSessionDocument
            token={token}
            eventID={eventDetails?._id}
            sessionID={sessionID}
            setShowAttachDocument={setIsDocAttach}
          />
        }
        toggleSaveChanges={() => setIsDocAttach(false)}
        directionOffCanvas="end"
        widthOffCanvas={canvasWidth}
      />

      <ModalDelete
        size="md"
        isOpen={isToggleDelete}
        toggle={() => {
          setIsToggleDelete(false);
        }}
        title="Delete Session"
        body={
          <DeleteForm
            setIsToggleDelete={setIsToggleDelete}
            token={token}
            eventID={eventDetails?._id}
            sessionID={sessionID}
          />
        }
      />
    </div>
  );
};

// Professional Styles
const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    padding: "24px 20px",
    boxSizing: "border-box",
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
  },
  headerSection: {
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "2px solid #e9ecef",
  },
  mainTitle: {
    fontSize: "26px",
    fontWeight: "700",
    color: "#111827",
    margin: "0 0 8px 0",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#6b7280",
    margin: 0,
    lineHeight: "1.6",
    maxWidth: "800px",
  },
  controlsContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "stretch",
    marginBottom: "24px",
    flexWrap: "wrap",
  },
  searchWrapper: {
    flex: "1",
    minWidth: "250px",
    position: "relative",
    maxWidth: "500px",
  },
  searchInput: {
    width: "100%",
    padding: "12px 44px 12px 48px",
    border: "2px solid #e5e7eb",
    borderRadius: "10px",
    fontSize: "15px",
    backgroundColor: "#ffffff",
    color: "#1f2937",
    boxSizing: "border-box",
    transition: "all 0.2s ease",
    outline: "none",
    height: "48px",
  },
  clearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "#f3f4f6",
    border: "none",
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    color: "#6b7280",
    fontSize: "20px",
    lineHeight: "1",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    transition: "all 0.15s ease",
  },
  addButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "12px 24px",
    background: "linear-gradient(135deg, #f68a20 0%, #e57a10 100%)",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 12px rgba(246, 138, 32, 0.3)",
    height: "48px",
    flexShrink: 0,
  },
  tableContainer: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
    border: "1px solid #e5e7eb",
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    background: "linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)",
    borderBottom: "2px solid #e5e7eb",
    flexWrap: "wrap",
    gap: "8px",
  },
  tableLabel: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#111827",
    letterSpacing: "0.3px",
  },
  tableCount: {
    fontSize: "13px",
    color: "#6b7280",
    fontWeight: "500",
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    minHeight: "300px",
    textAlign: "center",
    background: "white",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
  },
  emptyIcon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  emptyTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: "#212529",
  },
  emptyText: {
    margin: "0 0 24px 0",
    fontSize: "14px",
    color: "#6b7280",
  },
  noData: {
    padding: "40px 20px",
    textAlign: "center",
    color: "#6b7280",
    fontSize: "14px",
  },
};

export default Sessions;